


















import { Vue, Prop, Component } from "vue-property-decorator"

import RecipeHeader from "@/components/BaseComponents/RecipeHeader.vue"

@Component({
	components: {
		RecipeHeader
	}
})
export default class RecipeProcedure extends Vue {
	@Prop({ required: true }) recipe!: RecipeObject;
}
